module.exports = __webpack_public_path__ + "static/media/play-btn.e5f678bc.svg";